import { CONTRACT_CATEGORY } from 'constants/category';
import { PAGE_DEFAULT, ROW_DEFAULT } from 'constants/global';

export const EMPTY_DATA_SEARCH_REFERENCE_TEMPLATE_CONTRACT = {
    text_search: '',
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
    category:CONTRACT_CATEGORY
};
